module.exports = __webpack_public_path__ + "static/media/trezor.b4b364cc.svg";